const mq = {
  md: '768px',
  lg: '992px',
  xl: '1400px'
};

const mqTheme = {
  xs: 0,
  sm: 0,
  md: 768,
  lg: 992,
  xl: 1400
};

const mqIndex = {
  md: '768px',
  lg: '1040px',
  xl: '1400px'
};

export {
  mq,
  mqTheme,
  mqIndex,
};
